import React from 'react';

const About = () => {
    return (
        <div className='container'>
            <h3>Name: Aklima Akhter</h3>
            <p>My goal is become a junior developer, that's why i am trying to heart and soul.Everyday i am trying to finish my daily task on time .although i cannot completed my target.But i want to finish this courses on time and after course completed i want to be skilled person.  </p>
        </div>
    );
};

export default About;